import { MessageScreen } from '@/components/MessageScreen/MessageScreen';
import { useConfig } from '@/hooks/useConfig/useConfig';
import { useAirKeyTracePageView } from '@/utils/airKeyTrace';

export const DeviceError = () => {
  const { content, locale } = useConfig();
  useAirKeyTracePageView('device_not_supported');

  return (
    <MessageScreen
      iconPath={`${content.config.urlBase}${content.deviceNotSupported.img.src}`}
      iconSize={content.deviceNotSupported.img.width}
      title={content.deviceNotSupported.title[locale]}
      titleSize={20}
      body={content.deviceNotSupported.description[locale]}
    />
  );
};
